export const CONTAINER_THEMES = {
    auto: 'auto',
    dark: 'dark',
    light: 'light',
};
export const IGNORE_KEYPRESS = ['INPUT', 'TEXTAREA', 'ARC-MENU-ITEM'];
